import React, { useState } from "react";
import { Package } from "lucide-react";
import CategoriesTab from "./materials/CategoriesTab";
import BrandsTab from "./materials/BrandsTab";
import VendorsTab from "./materials/VendorsTab";
import PageHeader from "../../components/PageHeader";
import Tabs from "../../components/Tabs";

// v3_51: the SKU catalog / bulk-upload / catalog-review / purchase-order tabs were removed. The
// "material schema" is now the taxonomy (categories → sub-categories) + brands, assigned to each
// vendor as coverage (served sub-categories + brands per sub-category) on the Vendors tab.
const TABS = [
  { key: "categories", label: "Categories" },
  { key: "brands", label: "Brands" },
  { key: "vendors", label: "Vendors" },
];

const MaterialVendors = () => {
  const [activeTab, setActiveTab] = useState("categories");

  return (
    <div className="p-6 lg:p-8 flex flex-col gap-6 min-h-[calc(100vh-4rem)]">
      <PageHeader
        icon={Package}
        title="Material Taxonomy & Vendors"
        subtitle="Manage material categories, brands, and each vendor's coverage (served sub-categories + brands)"
      />

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <Tabs tabs={TABS} active={activeTab} onChange={setActiveTab} />
        <div className="p-5">
          {activeTab === "categories" && <CategoriesTab />}
          {activeTab === "brands" && <BrandsTab />}
          {activeTab === "vendors" && <VendorsTab />}
        </div>
      </div>
    </div>
  );
};

export default MaterialVendors;
